import { Type } from "class-transformer";

export class FairModel {

    public FairId: string;
    public FairName: string;
    @Type(() => Date)
    public Days: Array<Date>;

}
